const quiz = document.querySelector('[data-chron-quiz]');

if (quiz) {
  const questionAdvanceDelay = 650;
  const questions = Array.from(
    quiz.querySelectorAll('[data-chron-quiz-question]')
  );
  const progressItems = Array.from(
    quiz.querySelectorAll('[data-chron-quiz-progress]')
  );
  const progressList = quiz.querySelector('[data-chron-quiz-progress-list]');
  const conclusion = quiz.querySelector('[data-chron-quiz-conclusion]');
  const leadForm = quiz.querySelector('[data-chron-quiz-lead-form]');
  const leadMessage = quiz.querySelector('[data-chron-quiz-lead-message]');
  const leadSubmit = quiz.querySelector('[data-chron-quiz-lead-submit]');
  const resultScreens = Array.from(
    quiz.querySelectorAll('[data-chron-quiz-result]')
  );
  const resultKeys = resultScreens.map((screen) => screen.dataset.resultKey);
  const fallbackResultOrder = [
    'the_steakhouse_socialite',
    'the_pitmaster_general',
    'the_herd_wrangler',
    'the_lone_star'
  ];
  const answers = [];
  let activeIndex = 0;
  let pendingResultKey = '';
  let chronQuizSurveyId = '';
  let surveyTrackQueue = Promise.resolve();

  const getAjaxUrl = () => window.wlGlobalConfig && window.wlGlobalConfig.__ajax;

  const setLeadMessage = (message = '', isError = false) => {
    if (!leadMessage) {
      return;
    }

    leadMessage.innerText = message;
    leadMessage.classList.toggle('is-error', isError);
  };

  const setLeadSubmitting = (isSubmitting) => {
    if (!leadSubmit) {
      return;
    }

    leadSubmit.disabled = isSubmitting;
    leadSubmit.innerText = isSubmitting ? 'Submitting...' : 'Reveal My Results';
  };

  const setActiveQuestion = (index) => {
    activeIndex = Math.max(0, Math.min(index, questions.length - 1));
    quiz.classList.remove('is-showing-results');

    questions.forEach((question, questionIndex) => {
      const isActive = questionIndex === activeIndex;
      question.hidden = !isActive;
      question.classList.toggle('is-active', isActive);
    });

    resultScreens.forEach((resultScreen) => {
      resultScreen.hidden = true;
    });

    if (conclusion) {
      conclusion.hidden = true;
    }

    if (progressList) {
      progressList.hidden = false;
    }

    progressItems.forEach((item, itemIndex) => {
      item.classList.toggle('is-active', itemIndex === activeIndex);
      item.classList.toggle('is-complete', itemIndex < activeIndex);
      item.disabled = itemIndex >= activeIndex;
    });
  };

  const showConclusion = (resultKey) => {
    pendingResultKey = resultKey;
    activeIndex = questions.length;
    quiz.classList.remove('is-showing-results');

    questions.forEach((question) => {
      question.hidden = true;
      question.classList.remove('is-active');
    });

    resultScreens.forEach((resultScreen) => {
      resultScreen.hidden = true;
    });

    if (conclusion) {
      conclusion.hidden = false;
    }

    if (leadSubmit) {
      leadSubmit.dataset.wlEventProps = JSON.stringify({
        chron_quiz_result: resultKey,
        chron_quiz_result_title: getResultLabel(resultKey)
      });
    }

    progressItems.forEach((item) => {
      item.classList.add('is-complete');
      item.classList.remove('is-active');
      item.disabled = false;
    });

    if (progressList) {
      progressList.hidden = true;
    }
  };

  const showResult = (resultKey) => {
    const result =
      resultScreens.find((screen) => screen.dataset.resultKey === resultKey) ||
      resultScreens[0];

    activeIndex = questions.length;
    quiz.classList.add('is-showing-results');

    questions.forEach((question) => {
      question.hidden = true;
      question.classList.remove('is-active');
    });

    if (conclusion) {
      conclusion.hidden = true;
    }

    resultScreens.forEach((resultScreen) => {
      resultScreen.hidden = resultScreen !== result;
    });

    progressItems.forEach((item) => {
      item.classList.add('is-complete');
      item.classList.remove('is-active');
      item.disabled = false;
    });

    if (progressList) {
      progressList.hidden = true;
    }
  };

  const restartQuiz = () => {
    answers.length = 0;
    pendingResultKey = '';
    chronQuizSurveyId = '';
    surveyTrackQueue = Promise.resolve();
    quiz.querySelectorAll('[data-chron-quiz-answer]').forEach((button) => {
      button.classList.remove('is-selected', 'is-confirming');
    });

    if (leadForm) {
      leadForm.reset();
      setLeadMessage();
      setLeadSubmitting(false);
    }

    setActiveQuestion(0);

    if (quiz.scrollIntoView) {
      quiz.scrollIntoView({
        block: 'start'
      });
    }
  };

  const parseScores = (answerButton) => {
    try {
      const scores = JSON.parse(answerButton.dataset.scores || '{}');

      return scores && typeof scores === 'object' && !Array.isArray(scores)
        ? scores
        : {};
    } catch (error) {
      return {};
    }
  };

  const getEmptyScoreMap = () =>
    resultKeys.reduce((scoreMap, resultKey) => {
      scoreMap[resultKey] = 0;
      return scoreMap;
    }, {});

  const getQuizScoreState = () => {
    const totals = getEmptyScoreMap();
    const questionCounts = getEmptyScoreMap();
    const priorityScores = getEmptyScoreMap();
    const priorityQuestionIndex = questions.length - 1;

    answers.forEach((answer, questionIndex) => {
      if (!answer || !answer.scores) {
        return;
      }

      resultKeys.forEach((resultKey) => {
        const points = Number(answer.scores[resultKey] || 0);

        if (points <= 0) {
          return;
        }

        totals[resultKey] += points;
        questionCounts[resultKey] += 1;

        if (questionIndex === priorityQuestionIndex) {
          priorityScores[resultKey] = points;
        }
      });
    });

    return {
      totals,
      questionCounts,
      priorityScores
    };
  };

  const getHighestKeys = (keys, scoreMap) => {
    const highestScore = keys.reduce(
      (highest, key) => Math.max(highest, Number(scoreMap[key] || 0)),
      -Infinity
    );

    return keys.filter((key) => Number(scoreMap[key] || 0) === highestScore);
  };

  const getFallbackResultKey = (keys) =>
    fallbackResultOrder.find((resultKey) => keys.includes(resultKey)) ||
    keys[0] ||
    resultKeys[0];

  const getResultKey = () => {
    const { totals, questionCounts, priorityScores } = getQuizScoreState();
    let tiedResultKeys = getHighestKeys(resultKeys, totals);

    if (tiedResultKeys.length <= 1) {
      return tiedResultKeys[0] || resultKeys[0];
    }

    tiedResultKeys = getHighestKeys(tiedResultKeys, priorityScores);

    if (tiedResultKeys.length <= 1) {
      return tiedResultKeys[0] || resultKeys[0];
    }

    tiedResultKeys = getHighestKeys(tiedResultKeys, questionCounts);

    if (tiedResultKeys.length <= 1) {
      return tiedResultKeys[0] || resultKeys[0];
    }

    return getFallbackResultKey(tiedResultKeys);
  };

  const getResultLabel = (resultKey) => {
    const resultScreen = resultScreens.find(
      (screen) => screen.dataset.resultKey === resultKey
    );
    const resultTitle = resultScreen
      ? resultScreen.querySelector('h3')
      : null;

    return resultTitle ? resultTitle.innerText.trim() : resultKey;
  };

  const submitLeadForm = (event) => {
    event.preventDefault();

    const ajaxUrl = getAjaxUrl();
    const formData = new FormData(leadForm);
    const email = String(formData.get('email') || '').trim();
    const emailInput = leadForm.querySelector('[name="email"]');
    const newsletterInput = leadForm.querySelector('[name="blt_nl"]');
    const newsletterOptIn = newsletterInput ? newsletterInput.checked : false;

    if (!email && !newsletterOptIn) {
      showResult(pendingResultKey);
      return;
    }

    if (!email && newsletterOptIn) {
      setLeadMessage('Please enter your email address to sign up.', true);
      if (emailInput) {
        emailInput.focus();
      }
      return;
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setLeadMessage('Please enter a valid email address.', true);
      if (emailInput) {
        emailInput.focus();
      }
      return;
    }

    if (!ajaxUrl) {
      setLeadMessage('Could not submit the form. Please try again.', true);
      return;
    }

    setLeadMessage();
    setLeadSubmitting(true);
    formData.set('action', 'wl_submit_chron_quiz_lead');
    formData.set(
      'nonce',
      window.wlGlobalConfig ? window.wlGlobalConfig.__ajax_nonce : ''
    );
    formData.set('email', email);
    formData.set('blt_nl', newsletterOptIn ? 'true' : 'false');
    formData.set('result_key', pendingResultKey);

    surveyTrackQueue
      .catch(() => {})
      .then(() => {
        formData.set('survey_id', chronQuizSurveyId);

        return fetch(ajaxUrl, {
          method: 'POST',
          credentials: 'same-origin',
          body: formData
        });
      })
      .then((response) => response.json())
      .then((response) => {
        if (!response.success) {
          throw new Error(
            response.data && response.data.message
              ? response.data.message
              : 'Could not submit the form. Please try again.'
          );
        }

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'chron_quiz_lead_submit',
          chron_quiz_result: pendingResultKey,
          chron_quiz_blt_nl: newsletterOptIn,
          chron_quiz_survey_id:
            response.data && response.data.survey_id ? response.data.survey_id : '',
          chron_quiz_contact_id:
            response.data && response.data.contact_id ? response.data.contact_id : '',
          chron_quiz_associated_to_survey: Boolean(
            response.data && response.data.associated_to_survey
          )
        });

        showResult(pendingResultKey);
      })
      .catch((error) => {
        setLeadMessage(error.message, true);
        setLeadSubmitting(false);
      });
  };

  const trackSurveyAnswer = (questionIndex, answer) => {
    const ajaxUrl = getAjaxUrl();

    if (!ajaxUrl) {
      return;
    }

    surveyTrackQueue = surveyTrackQueue
      .catch(() => {})
      .then(() => {
        const formData = new FormData();
        formData.set('action', 'wl_track_chron_quiz_survey_answer');
        formData.set(
          'nonce',
          window.wlGlobalConfig ? window.wlGlobalConfig.__ajax_nonce : ''
        );
        formData.set('survey_id', chronQuizSurveyId);
        formData.set('question_index', questionIndex);
        formData.set('answer', answer);

        return fetch(ajaxUrl, {
          method: 'POST',
          credentials: 'same-origin',
          body: formData
        })
          .then((response) => response.json())
          .then((response) => {
            if (!response.success) {
              throw new Error(
                response.data && response.data.message
                  ? response.data.message
                  : 'Could not track quiz answer.'
              );
            }

            if (response.data && response.data.survey_id) {
              chronQuizSurveyId = response.data.survey_id;
            }
          })
          .catch((error) => {
            if (window.console && window.console.warn) {
              window.console.warn(error.message);
            }
          });
      });
  };

  quiz.addEventListener('click', (event) => {
    const restartButton = event.target.closest('[data-chron-quiz-restart]');

    if (restartButton) {
      restartQuiz();
      return;
    }

    const showResultButton = event.target.closest(
      '[data-chron-quiz-show-result]'
    );

    if (showResultButton) {
      showResult(pendingResultKey);
      return;
    }

    const progressButton = event.target.closest('[data-chron-quiz-progress]');

    if (progressButton) {
      const questionIndex = Number(progressButton.dataset.questionIndex);

      if (questionIndex < activeIndex) {
        setActiveQuestion(questionIndex);
      }

      return;
    }

    const answerButton = event.target.closest('[data-chron-quiz-answer]');

    if (!answerButton) {
      return;
    }

    const questionIndex = Number(answerButton.dataset.questionIndex);
    const selectedScores = parseScores(answerButton);
    answers[questionIndex] = {
      answerIndex: Number(answerButton.dataset.answerIndex),
      scores: selectedScores
    };

    questions[questionIndex]
      .querySelectorAll('[data-chron-quiz-answer]')
      .forEach((button) => {
        button.classList.remove('is-confirming');
        button.classList.toggle('is-selected', button === answerButton);
      });

    void answerButton.offsetWidth;
    answerButton.classList.add('is-confirming');

    const currentQuestion = questions[questionIndex]
      .querySelector('h3')
      .innerText.trim();
    const chosenAnswer = answerButton.innerText.trim();

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'chron_quiz_answer',
      chron_quiz_question: currentQuestion,
      chron_quiz_answer: chosenAnswer
    });

    trackSurveyAnswer(questionIndex, chosenAnswer);

    window.setTimeout(() => {
      answerButton.classList.remove('is-confirming');

      if (questionIndex + 1 >= questions.length) {
        showConclusion(getResultKey());
      } else {
        setActiveQuestion(questionIndex + 1);
      }
    }, questionAdvanceDelay);
  });

  if (leadForm) {
    leadForm.addEventListener('submit', submitLeadForm);
  }

  setActiveQuestion(0);
}
